module.exports = __webpack_public_path__ + "img/factor_a_blue.821b1185.svg";